import React from "react";
import webLogo from "../asset/web_logo/orange.png";
import { FaListUl } from "react-icons/fa";

import { useNavigate } from "react-router-dom";

export default function Nav() {
    const navigate = useNavigate();
    return (
        <>
            <div className="nav flex medel around">
                <div>
                    <img onClick={() => navigate('/')} className="web-logo pointer" src={webLogo} alt="Web Logo" srcset="" />
                </div>
                <div>
                    <FaListUl onClick={() => navigate('/all')} className="add-icon pointer" />
                </div>
            </div>
        </>
    )
}